/**
 * AccountingIcon — pictograma „Contabilitate" (sidebar / nav).
 *
 * Sursă: `pictograme/New folder (3)/SVG/Asset 44.svg` — contabil cu laptop
 * + frunza-cont peste cap (reprezentare „accountant working").
 *
 * Convertit pentru theming currentColor: păstrate doar stroke-urile (cele 7
 * path-uri outline), eliminate cele 2 fill-uri albe redundante care erau
 * doar layer de „lift" peste background-ul desktop-ului. Stroke-width 7
 * pentru paritate cu iconurile dense Lucide (h-5 w-5).
 */

interface AccountingIconProps {
  className?: string;
  size?: number;
  'aria-hidden'?: boolean;
}

export function AccountingIcon({
  className = '',
  size = 20,
  'aria-hidden': ariaHidden,
}: AccountingIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 159.17 159.17"
      width={size}
      height={size}
      className={className}
      role={ariaHidden ? undefined : 'img'}
      aria-label={ariaHidden ? undefined : 'Contabilitate'}
      aria-hidden={ariaHidden}
      fill="none"
      stroke="currentColor"
      strokeWidth="12"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* Laptop body — outline */}
      <path d="M93.87,145.85v-45.08c0-3.94-3.19-7.13-7.13-7.13H9.04c-3.93,0-7.12,3.19-7.13,7.12l-.08,56.59h92.04" />
      {/* Head — outline (hair / contour) */}
      <path d="M72.92,41.31c-.37-2.78-.56-5.67-.56-8.63h-.02c0-17.03,13.21-30.84,29.5-30.84s29.5,13.81,29.5,30.84h0c0,2.97-.19,5.85-.56,8.63h-.02c-.47,4.02-3.51,6.85-7.34,6.85-.4,0-.78-.05-1.16-.12-3.22,13.09-11.14,22.37-20.42,22.37s-17.2-9.27-20.42-22.37c-.38.06-.76.12-1.16.12-3.83,0-6.87-2.83-7.34-6.85Z" />
      {/* Brow line */}
      <path d="M118.92,36.25c-13.05-.73-25.43-7.25-29.82-16.21" />
      {/* Right top connector — folder top right */}
      <path d="M103.25,133.81h26.49c2.25,0,4.07-1.82,4.07-4.07v-20.41" strokeLinecap="butt" />
      {/* Right body — accountant work surface */}
      <path d="M123.63,70.41h20.47c7.32,0,13.25,5.93,13.25,13.25v61.93c0,6.5-5.27,11.77-11.77,11.77h-51.71" />
      {/* Left body — laptop screen edge */}
      <path d="M46.32,84.44v-.79c0-7.32,5.93-13.25,13.25-13.25h14.6" strokeLinecap="butt" />
      {/* Vertical dash — divider */}
      <line x1="133.81" y1="98.24" x2="133.81" y2="109.33" />
      {/* Top horizontal small line — pen / pencil */}
      <line x1="74.17" y1="70.41" x2="80" y2="70.41" />
    </svg>
  );
}
